var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio radio-css"},[_c('input',{attrs:{"type":"radio","disabled":_vm.disabled,"name":_vm.name},domProps:{"checked":_vm.isChecked,"value":_vm.value},on:{"input":event => _vm.onInput(event)}}),_c('label',{on:{"click":event => event.target.previousSibling.click()}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }